/* Gallery slider - event-template page */
$(function(){
    if($('.img-gallery.shows-six-photos-gallery').find('.img-gallery__media').length > 6)
        $('.js-show-hide-btn').show();
    else
        $('.js-show-hide-btn').hide();
});
